module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("94kkw"))).then(() => parcelRequire('8rm4T'));